// Truwear — client-side validation for the custom-file-option block.
// Uses event delegation (a single document-level listener) rather than
// binding per-input on page load, so it works correctly for blocks added
// or re-rendered by the theme editor (a <script src> tag inserted via a
// section re-render does not re-execute) and for multiple instances of
// this block on the same page (e.g. product page + quick-add modal).
(function () {
  /**
   * @param {HTMLInputElement} input
   * @param {HTMLElement} errorEl
   * @param {HTMLElement} nameEl
   * @param {string} message
   */
  function showError(input, errorEl, nameEl, message) {
    input.value = '';
    // Don't leave the field stuck invalid over an attempt the customer has
    // since abandoned or corrected -- native `required` (if set) already
    // independently blocks an empty submission on its own.
    input.setCustomValidity('');
    errorEl.textContent = message;
    errorEl.classList.remove('hidden');
    nameEl.textContent = 'No file chosen';
    nameEl.classList.remove('custom-product-option__file-name--selected');
  }

  /**
   * @param {HTMLInputElement} input
   * @param {HTMLElement} errorEl
   * @param {HTMLElement} nameEl
   */
  function validateFile(input, errorEl, nameEl) {
    errorEl.classList.add('hidden');
    errorEl.textContent = '';
    input.setCustomValidity('');

    const file = input.files && input.files[0];
    if (!file || !file.name) {
      nameEl.textContent = 'No file chosen';
      nameEl.classList.remove('custom-product-option__file-name--selected');
      return;
    }

    const acceptedTypes = (input.getAttribute('accept') || '')
      .split(',')
      .map((ext) => ext.trim().toLowerCase())
      .filter(Boolean);
    const fileNameLower = file.name.toLowerCase();
    const hasAcceptedExtension =
      acceptedTypes.length === 0 || acceptedTypes.some((ext) => fileNameLower.endsWith(ext));

    if (!hasAcceptedExtension) {
      showError(input, errorEl, nameEl, `That file type isn't accepted. Accepted types: ${input.getAttribute('accept')}`);
      return;
    }

    const maxSizeMb = parseFloat(input.dataset.maxSizeMb) || 10;
    const maxBytes = maxSizeMb * 1024 * 1024;

    if (file.size > maxBytes) {
      showError(input, errorEl, nameEl, `File is too large. Maximum size is ${maxSizeMb} MB.`);
      return;
    }

    nameEl.textContent = file.name;
    nameEl.classList.add('custom-product-option__file-name--selected');
  }

  document.addEventListener('change', (event) => {
    const input = /** @type {HTMLElement} */ (event.target)?.closest?.('.custom-product-option__file-input');
    if (!input) return;

    const wrapper = input.closest('.custom-product-option--file');
    const nameEl = wrapper?.querySelector('.custom-product-option__file-name');
    const errorEl = wrapper?.querySelector('.custom-product-option__file-error');
    if (!nameEl || !errorEl) return;

    validateFile(/** @type {HTMLInputElement} */ (input), errorEl, nameEl);
  });
})();
